import { t } from '@lingui/core/macro';
import { BooleanFilter } from './BooleanFilter';
export const indemnityFilterLabel = () => t({ message: 'Indemnity', comment: 'Insights: Indemnity filter' });
export function IndemnityFilter() {
    return <BooleanFilter name="metadataDocumentIndemnity" label={indemnityFilterLabel()}/>;
}
